module.exports = __webpack_public_path__ + "media/images/mobile/abouts/banner-insights2-43b154859c3e4c3e13dfdb16169aceb5.png";